import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/legal-firm`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchLegalFirms = (payload) => apiHelper(API_URL, 'GET', payload);
export const createLegalFirm = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchLegalFirm = (legalFirmId) => apiHelper(`${API_URL}/${legalFirmId}`, 'GET');
export const modifyLegalFirm = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteLegalFirmApi = (legalFirmId) => apiHelper(`${API_URL}/${legalFirmId}`, 'DELETE');
export const changeStatus = (legalFirmId) => apiHelper(`${API_URL}/change-status/${legalFirmId}`, 'POST');

